import React from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";

export const PageShell = ({ children, max = "max-w-6xl", progressBar = null, withNav = true }) => {
  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      {progressBar}
      {withNav && (
        <header className="border-b border-[#E5E7EB] bg-white/80 backdrop-blur-sm sticky top-0 z-40">
          <div className={`mx-auto ${max} px-6 md:px-10 h-24 flex items-center justify-between`}>
            <Logo />
          </div>
        </header>
      )}
      <motion.main
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className={`mx-auto ${max} px-6 md:px-10 py-10 md:py-16`}
      >
        {children}
      </motion.main>
    </div>
  );
};
